module.exports = __webpack_public_path__ + "img/Lindsay Cherry at Hoge House, 1954.f07e5e9a.jpg";